import VForm from '@/vuetify_custom/v-form'
import VModal from '@/vuetify_custom/v-modal_v1'
import { setAssetInventoryTopicSaveApi } from '../service'
function initData() {
    return {
        name: null,
        inventory_start: null,
        inventory_end: null,
    }
}
export default {
    data() {
        return {
            id:null,
            show:false,
            saveLoading: false,
            params: initData(),
        }
    },
    computed:{
        fields_list() {
            return [
                {
                    label: '批次名称', 
                    key:'name',
                    rules:[val => {
                        return !!val || '必填'
                      }],
                },
                {
                    label: '盘点开始时间',
                    key:'inventory_start',
                    type:'date_picker_v1',
                    allowedDates: (val) => {
                       if (val > this.params.inventory_end) {
                        return false
                       }
                       return true
                    },
                    cols: 12,
                    rules:[val => {
                      return !!val || '必选'
                    }],
                },
                {
                    label: '盘点结束时间',
                    key:'inventory_end',
                    type:'date_picker_v1',
                    cols: 12,
                    allowedDates: (val) => {
                        if (val < this.params.inventory_start) {
                         return false
                        }
                        return true
                     },
                    rules:[val => {
                      return !!val || '必选'
                    }],
                }
            ]
        },
    },
    mounted() {
      //   this.edit()
     // this.show = false
    },
    methods: {

        edit(data) {
            this.params = data ? JSON.parse(JSON.stringify(data)) : initData()
            this.$nextTick(() => {
                this.show = true  
            })
        },
        submit() {
         if (this.$refs.form.validate()) {
             this.saveLoading = true
             setAssetInventoryTopicSaveApi(this.params).then(res => {
                 this.show = false
              this.$emit('success')
            }).finally(() => {
                this.saveLoading = false
            })
         }
        }
    },
    render() {
        const _this = this
        return <VModal 
                    dynamicHeight
                    heightRate={0.5}
                    v-model={this.show}
                    title={_this.params.id ? '编辑盘点批次' : '新增盘点批次'}
                    loading={this.saveLoading}
                    width={500}
                    ref="modal"
                    // cancelText={_this.params.pigeonhole_flag === 1 ? '' : '取消'}
                    // okText={_this.params.pigeonhole_flag === 1 ? '关闭' : '确定'}
                    on={{
                    ok: () => {
                        _this.submit()
                    }
                    }}
                >
                    <div>
                        <VForm 
                            ref="form"
                            v-model={_this.params}
                            fields={_this.fields_list}
                            >
                        </VForm>
                    </div>
                </VModal>
    }
}